import { parse, format } from "date-fns"; // Ensure date-fns is installed
import { colors } from "../../../../../utils/colors";
import { convertTsToLocal } from "../../../../../utils/displayTime";
import { getSpace, generateDayData, formatDateInAMPM } from "../common/adUtils";
import { tViews } from "../../../../../utils/table";

export const getCellElem = (chartSelector, serieId, xId, setSelectedElem) => {
    const chartElement = document?.querySelector(chartSelector);
    if(chartElement?.shadowRoot) {
        const cellElement = chartElement.shadowRoot.querySelector(`rect[series = '${serieId}'][xid = '${xId}']`);
        if (cellElement !== null) {
            setSelectedElem((prevState) => ({
                prev: prevState.current,
                current: cellElement,
            }));
        }
    }
}

export const getConfig = (apiRes, setHourSelected, timePeriod, setSelectedElem, adKey, actions, id) => {
    if(apiRes?.data?.data?.length === 0) return apiRes?.data;
    const range = apiRes?.data?.metadata?.anomaly_rate
    const heatmapConfigWithData = {
        data: [],
        ariaLabel: id,
        // Accessibility: ARIA label for each cell
        cellAriaLabel: (e) => `Value: ${e.value}`,
        margin: { top: 2, right: 2, bottom: 80, left: 50 },
        yOuterPadding: 0.1,
        axisLeft: { tickSize: 0 },
        axisBottom: { tickSize: 0 },
        onClick: (e) => {
            if(e.value !== null) {
                const formattedDate = formatDateInAMPM(e.data.date);
                setHourSelected(formattedDate)
                actions.saveKpiDateForTable(formattedDate);
                if(id === "AD Heatmap Chart") {
                    getCellElem(".ss-heatmap-chart hbr-heatmap-chart", e.serieId, e.data.x, setSelectedElem);
                } else if(id === "AD Trend Heatmap Chart") {
                    getCellElem(".ss-trend-chart hbr-heatmap-chart", e.serieId, e.data.x, setSelectedElem);
                }
            }
        },
        itemTooltip: dataItem => {
            return getItemTooltip(dataItem);
        },
        colors: {
            type: "sequential",
            colors: [colors.lavendar35, colors.lavendar95],
            emptyColor: colors.gray90,
            maxValue: range.min,
            minValue: range.max
        },
        legends: [
            {
                length: 1300,
                thickness: 12,
                tickSize: 0,
                tickSpacing: 6
            },
        ],
    };

    const getItemTooltip = (dataItem) => `
        <div
            style="
            font-family: var(--hbr-font-body);
            fontSize: 12px;
            lineHeight: 16px;
            color: var(--hbr-color-neutral-text, #23282E);
            "
        >
            <div
            style="
                width: 16px;
                height: 16px;
                background-color: ${dataItem.color};
                display: inline flow-root;
                vertical-align: middle;
            "
            ></div>
            <div
            style="
                height: 16px;
                padding: 0 4px;
                display: inline flow-root;
                vertical-align: middle;
            "
            >
            ${dataItem.serieId} - ${dataItem.data.x}
            </div>
            ${dataItem.data.y !== undefined ? `
                <div
                    style="
                        height: 16px;
                        font-weight: 600;
                        display: flex flow-root;
                        vertical-align: middle;
                        padding: 15px 0 10px 0;
                    "
                    >
                    ${tViews('anomalyRatewithColon')} ${getSpace(1, '')}${dataItem.data.y}% \n
            </div>` : ''}
            ${id === "AD Trend Heatmap Chart" &&
                dataItem.data.usage !== undefined ?`
                <div
                    style="
                        height: 16px;
                        font-weight: 600;
                        display: flex flow-root;
                        vertical-align: middle;">
                    ${tViews('usagewithColon')} ${getSpace(15, '')}${dataItem.data.usage} \n
                    </div>` :''
            }
        </div>`;

    const groupedData = new Map();

    apiRes.data.data.forEach((item) => {
        const date = convertTsToLocal(item.entry_ts);
        const dayLabel = format(date, "EEE d"); // Format as "WED 19th"
        const hourLabel = format(date, "h:mm aa"); // Format as "12:00", "1:00", etc.

        // If the dayLabel doesn't exist in the Map, initialize it
        if (!groupedData.has(dayLabel)) {
            groupedData.set(dayLabel, generateDayData(timePeriod[0]));
        }

        groupedData.get(dayLabel).some(obj => {

            if(obj.x.trim() === hourLabel.trim()) {
                obj.y = item.anomaly_rate;
                obj.date = date;
                if(id === "AD Trend Heatmap Chart") {
                     obj.usage = item.display_app_usage;
                }
            }
            return false;
        })
    });

    // Sort the data points within each group by hourLabel
    heatmapConfigWithData.data = Array.from(groupedData.entries())
        .map(([id, data]) => ({
            id,
            data: data.sort((a, b) => {
                // Parse hourLabel to Date objects for comparison
                const timeA = parse(a.x, "h:mm aa", new Date());
                const timeB = parse(b.x, "h:mm aa", new Date());
                return timeA - timeB; // Sort in ascending order
            }),
        }));

    if((id === "AD Trend Heatmap Chart" && !adKey.adDate && !adKey.kpiDate) || 
        (id === "AD Trend Heatmap Chart" && !adKey.kpiDate)) {
        let initialHour = new Date(apiRes.data.data[0].entry_ts);
        const localTime = new Date(initialHour.getTime() - initialHour.getTimezoneOffset() * 60000);
        const formattedDate = formatDateInAMPM(localTime);
        setHourSelected(formattedDate);
        actions.saveKpiDateForTable(formattedDate);
    } else if(adKey.kpiDate) {
        const formattedKpiDate = formatDateInAMPM(new Date(adKey.kpiDate));
        setHourSelected(formattedKpiDate);
        actions.saveKpiDateForTable(formattedKpiDate);
    } else {
        const formattedAdDate = formatDateInAMPM(new Date(adKey.adDate));
        setHourSelected(formattedAdDate);
        actions.saveKpiDateForTable(formattedAdDate);
    }

    return heatmapConfigWithData;
};